import _ from "lodash"

export let randomCache = {}

export const getRandom = (id, choice) => {
  if (id && id in randomCache) {
    return choice[randomCache[id]]
  }
  const roll = Math.floor(Math.random() * choice.length)
  if (id) {
    randomCache[id] = roll
  }

  return choice[roll]
}

export const setRandomCache = newCache => {
  randomCache = newCache
}

export const getShuffleOrder = (id, choices) => {
  if (id && id in randomCache) {
    return randomCache[id]
  }

  let choiceIndices = choices.map((x, i) => i)

  const newOrder = _.shuffle(choiceIndices)

  randomCache[id] = newOrder

  return newOrder
}

export const getCachedOutput = () => {
  if (randomCache === {}) {
    return []
  }

  let randomArray = Object.entries(randomCache).map(([id, value]) => {
    return {
      id,
      value
    }
  })
  return randomArray
}

export const getCachedOutputAsObject = () => {
  return randomCache
}

export let clearRandomCache = () => {
  randomCache = {}
}
